import script from "./PaletteStudioCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./PaletteStudioCreator.vue?vue&type=script&setup=true&lang=js"

import "./PaletteStudioCreator.vue?vue&type=style&index=0&id=0d6cb06e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6cb06e"]])

export default __exports__